import { get } from 'svelte/store';
import * as PROXY from '../../../common/api.js';
import * as PEGASUS from '@smatch/pegasus-api-docs';
import { BID_STORE, BID_HASH } from './store.js';
import { ORGANIZATION_KEY, USER_KEY } from '../../authentication/services/store.js';
const DOMAIN = import.meta.env.VITE_DOMAIN;
export * from './types.js';
/* eslint-disable arrow-body-style */
// Filter Bids
export const filterBids = async (parameters = {}) => {
    if (DOMAIN !== 'internal') {
        parameters.organizationKey = get(ORGANIZATION_KEY) ?? '';
        parameters.ownerKey = get(USER_KEY) ?? '';
    }
    return PROXY.handleFilter(PEGASUS.filterBids, parameters)
        .then(bids => PROXY.updateStoreBulk(BID_STORE, bids));
};
// Fetch Bid
export const fetchBid = async (keys, onError) => {
    return PROXY.handleFetch(PEGASUS.fetchBid, keys)
        .then(({ data, statusCode }) => {
        if (onError?.(statusCode) === true) {
            return {};
        }
        if (statusCode !== 'STATUS_200') {
            PROXY.handleApiError(statusCode);
            return {};
        }
        return PROXY.updateStore(BID_STORE, null, data);
    });
};
// Create Bid
export const createBid = async (body) => {
    return PROXY.handleCreate(PEGASUS.createBid, body)
        .then(response => PROXY.updateStore(BID_STORE, BID_HASH, response));
};
// Update Bid
export const updateBid = async (keys, body) => {
    return PROXY.handleUpdate(PEGASUS.updateBid, keys, body)
        .then(response => PROXY.updateStore(BID_STORE, BID_HASH, response));
};
// Delete Bid
export const deleteBid = async (keys) => {
    return PROXY.handleDelete(PEGASUS.deleteBid, keys)
        .then(response => PROXY.removeFromStore(BID_STORE, BID_HASH, keys.bidKey, response));
};
// Update Bid State
export const updateBidState = async (keys, body) => {
    return PROXY.handleUpdate(PEGASUS.updateBidState, keys, body)
        .then(response => PROXY.updateStore(BID_STORE, BID_HASH, response));
};
// Upload Bid Stock File
export const uploadBuyerBidStockFile = async (keys, body) => PROXY.handleUpload(PEGASUS.uploadBidStockFile, keys, body);
/* eslint-enable arrow-body-style */ 
